import React from 'react';
import styles from './genres.module.scss';

function Genres({ male, female, ...props }) {
  return (
    <div className={styles.genre}>
      <div className={styles.score}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34.141"
          height="34.146"
          viewBox="0 0 34.141 34.146"
        >
          <path
            id="male"
            data-name="male"
            d="M2370.441,785.565l-6.674.218,4.035,4.036-4.541,4.541a13.487,13.487,0,1,0,5.017,18.145l0,0a13.5,13.5,0,0,0-.177-13.3l4.541-4.54,4.035,4.035.218-6.674.218-6.674Zm-7.958,23.752h0a6.874,6.874,0,1,1-1.568-8.543l.788.788a6.872,6.872,0,0,1,.782,7.754Z"
            transform="translate(-2342.974 -785.347)"
            fill="#54C6E0"
          />
        </svg>
        <div>
          <strong>{`${male?.toFixed(0)}% `}</strong>
          <span>MALE</span>
        </div>
      </div>
      <div className={styles.score}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26.971"
          height="41.53"
          viewBox="0 0 26.971 41.53"
        >
          <path
            id="female"
            data-name="female"
            d="M2479.847,795.141a13.487,13.487,0,0,0-25.3-6.5v0a13.493,13.493,0,0,0,8.4,19.543v2.931h-5.707v6.847h5.707v5.218h6.847v-5.218h5.706V811.12h-5.706v-2.932A13.49,13.49,0,0,0,2479.847,795.141Zm-18.495,4.705a6.87,6.87,0,0,1-1.014-8.015h0a6.873,6.873,0,1,1,1.013,8.016Z"
            transform="translate(-2452.876 -781.655)"
            fill="#D85A8F"
          />
        </svg>
        <div>
          <strong>{`${female?.toFixed(0)}% `}</strong>
          <span>FEMALE</span>
        </div>
      </div>
    </div>
  );
}
export default Genres;
